import React, { useContext } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import SmoothScroll from "./components/SmoothScroll";
import { ThemeContext } from "./contexts/ThemeContext";
import useMobileCheck from "./hooks/useMobileCheck";
import Home from "./pages/home/Home";
import Projects from "./pages/portfolio/Projects";

export default function App() {
  const { toggleDarkMode } = useContext(ThemeContext);

  const isMobile = useMobileCheck();

  return (
    <>
      <BrowserRouter>
        <Header toggleDarkMode={toggleDarkMode} />
        <SmoothScroll disabled={isMobile}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<Projects />} />
          </Routes>
        </SmoothScroll>
      </BrowserRouter>
    </>
  );
}
